import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { AboutRequest } from './aboutrequest';

export class AboutAPI extends APIImpl<AboutRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/faq.json
        return this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH 
        ? "/en/en/ENG/faq_iosformat.json" : "/my/my/BURMESE/faq_iosformat.json";
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/about/aboutapi.ts